import { Button, EmailOutlineRoundedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { UserInvitationModal } from '../user-invitation-modal';

export default function UserInvitationButton() {
  const [
    isUserInvitationModalOpen,
    { open: openUserInvitationModal, close: closeUserInvitationModal },
  ] = useDisclosure();

  const handleOpen = () => {
    openUserInvitationModal();
  };

  const handleClose = () => {
    closeUserInvitationModal();
  };

  return (
    <>
      <Button onClick={handleOpen} size='large' startIcon={<EmailOutlineRoundedIcon />}>
        Invite User
      </Button>
      <UserInvitationModal open={isUserInvitationModalOpen} onClose={handleClose} />
    </>
  );
}
